export enum NotificationSubtype {
  PAYMENT = 'payment',
  DOCUMENT = 'document',
  GENERAL = 'general',
  ENROLLMENT = 'enrollment',
}

export class Notification {
  id: string;
  subtype: NotificationSubtype;
  title: string;
  content: string;
  created_at: string;
  is_read: boolean;
  is_deletable: boolean;
  is_open: boolean;
  icon: string;

  constructor(notification) {
    this.id = notification.id;
    this.subtype = notification.subtype || NotificationSubtype.GENERAL;
    this.title = notification.title;
    this.content = notification.body;
    this.created_at = notification.created_at;
    this.is_read = notification.is_read;
    this.is_deletable = notification.is_deletable;
    this.is_open = false;

    // TODO: configurable icons
    switch (notification.subtype) {
      case NotificationSubtype.GENERAL:
        this.icon = 'wellness';
        break;
      case NotificationSubtype.DOCUMENT:
        this.icon = 'claims';
        break;
      case NotificationSubtype.ENROLLMENT:
        this.icon = 'benefits';
        break;
      case NotificationSubtype.PAYMENT:
        this.icon = 'costs';
        break;
      default:
        this.icon = 'benefits';
        break;
    }
  }
}

export interface NotificationArgs {
  notification: Notification;
  isNotificationOpen: boolean;
  readNotification?: () => void;
  deleteNotification?: (id: number) => void;
  showMobileNotification?: () => void;
  hideMobileNotification?: () => void;
  isNotificationOpenChange?: (isOpen: boolean) => void;
}
